
<router-outlet></router-outlet>
<app-controlchat-v2-widget *ngIf="useControlchatV2 && showGlobalChatWidget"></app-controlchat-v2-widget>
<app-controlchat-widget *ngIf="!useControlchatV2 && showGlobalChatWidget"></app-controlchat-widget>
